import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import azureClient from '../api/azureClient';

const DataRefreshContext = createContext();

export const useDataRefresh = () => {
  const context = useContext(DataRefreshContext);
  if (!context) {
    throw new Error('useDataRefresh must be used within a DataRefreshProvider');
  }
  return context;
};

export const DataRefreshProvider = ({ children }) => {
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [lastUpdate, setLastUpdate] = useState(new Date());

  // Trigger a refresh across all components listening to data changes
  const triggerRefresh = useCallback((source = 'unknown') => {
    console.log(`Data refresh triggered by: ${source}`);
    setRefreshTrigger(prev => prev + 1);
    setLastUpdate(new Date());
  }, []);

  // Specific refresh triggers
  const refreshAssociations = useCallback(() => {
    // Clear the paginated cache so fresh data is fetched
    if (azureClient.clearPaginatedCache) {
      azureClient.clearPaginatedCache();
    }
    triggerRefresh('associations');
  }, [triggerRefresh]);

  const refreshActionItems = useCallback(() => {
    triggerRefresh('actionItems');
  }, [triggerRefresh]);

  const value = useMemo(() => ({
    refreshTrigger,
    lastUpdate,
    triggerRefresh,
    refreshAssociations,
    refreshActionItems,
  }), [refreshTrigger, lastUpdate, triggerRefresh, refreshAssociations, refreshActionItems]);

  return <DataRefreshContext.Provider value={value}>{children}</DataRefreshContext.Provider>;
};

export default DataRefreshContext;
